/**
 * @file: 坐标相关工具函数
 * @author: xiaolong.huang@dmall.com
 */

import Config from '../config/index';
import Utils from '../utils/util';

// 厘米转像素
export function cmToPx(cm: any): number {
    let cmToNumber: number = Utils.toNumberForce(cm);

    let cmProportion = Config.get({
        moduleName: 'base',
        key: 'cmProportion'
    });

    return Utils.math(cmToNumber, cmProportion, '*');
}

// 像素转厘米
export function pxToCm(px: any): number {
    let pxToNumber: number = Utils.toNumberForce(px);

    let cmProportion = Config.get({
        moduleName: 'base',
        key: 'cmProportion'
    });

    return Utils.math(pxToNumber, cmProportion, '/');
}

// 缩放
export function scale(num: any): number {
    let toNumber: number = Utils.toNumberForce(num);

    let scale: number = Config.get({
        moduleName: 'transform',
        key: 'scale'
    });

    return Utils.math(toNumber, scale, '*');
}

// 缩放还原
export function unscale(num: any): number {
    let toNumber: number = Utils.toNumberForce(num);

    let scale: number = Config.get({
        moduleName: 'transform',
        key: 'scale'
    });

    return Utils.math(toNumber, scale, '/');
}

export function createMatrix(scale, position) {
    var sx = scale.x ? scale.x : 1;
    var sy = scale.y ? scale.y : 1;
    var x = position.x ? position.x : 0;
    var y = position.y ? position.y : 0;

    sx = Number(sx);
    sy = Number(sy);
    x = Number(x);
    y = Number(y);

    if (isNaN(sx) || isNaN(sy) || isNaN(x) || isNaN(y)) {
        return 'matrix(1, 0, 0, 1, 0, 0)';
    }

    return `matrix(${sx}, 0, 0, ${sy}, ${x}, ${y})`;
}
